<template>
  <teleport to="body">
    <div
      id="modal"
      v-if="store.visible"
      class="modal"
      @click.self="handleClose"
      @touchend.self.prevent.stop="handleClose"
      style="display: block"
    >
      <div class="modal-wrap">
        <div class="modal-content">
          <h2>
            ご利用上の注意
            <button
              class="close"
              @click="handleClose"
              @touchend.prevent.stop="handleClose"
              aria-label="閉じる"
            ></button>
          </h2>
          <p>
            一般財団法人日本気象協会が提供する本システムを通じて入手した全ての情報について、無断転載や二次利用することはできません。<br />
            気象現象は短時間で変化する可能性があり、また、予測については不確実な場合があります。<br />
            本情報の利用により発生した損害について、弊社ではいかなる責任も負わないものとしますので、ご了承ください。
          </p>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { useNoticeModalStore } from '@/stores/noticeModal'
const store = useNoticeModalStore()

const handleClose = (event?: Event) => {
  // Safariでタップ後にフォーカスが残るのを防止するため、イベントを停止してからモーダルを閉じる
  event?.preventDefault()
  event?.stopPropagation()

  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur()
  }

  store.close()

  requestAnimationFrame(() => {
    document.body.focus()
  })
}
</script>
